import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { MISSING_IMG } from '../../config/constants';
import { jsx as _jsx } from "react/jsx-runtime";

var LazyImage = function LazyImage(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      dataSizes = _ref.dataSizes,
      dataSrcSet = _ref.dataSrcSet,
      preloadImg = _ref.preloadImg,
      src = _ref.src,
      style = _ref.style;
  return /*#__PURE__*/_jsx("img", {
    alt: alt,
    className: cc(['lazyload', className]),
    "data-sizes": dataSizes,
    "data-src": src,
    "data-srcset": dataSrcSet,
    src: preloadImg,
    style: style
  });
};

LazyImage.defaultProps = {
  className: '',
  dataSizes: 'auto',
  dataSrcSet: '',
  preloadImg: MISSING_IMG,
  style: {}
};
LazyImage.propTypes = {
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  dataSizes: PropTypes.string,
  dataSrcSet: PropTypes.string,
  preloadImg: PropTypes.string,
  src: PropTypes.string.isRequired,
  style: PropTypes.shape()
};
export default /*#__PURE__*/memo(LazyImage);